module.exports = __webpack_public_path__ + "img/paper-kraft-packetgrup.dfee3e60.jpg";